'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _iview = require('iview');

var _iconfont = require('@/components/iconfont');

var _iconfont2 = _interopRequireDefault(_iconfont);

var _play = require('@/mixins/play');

var _play2 = _interopRequireDefault(_play);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_play2.default],
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      fixStyle: {
        'bottom': 0
      },
      showInfo: false,
      courseID: '',
      courseName: '',
      isBottom: true,
      copyRightData: ''
    };
  },

  watch: {
    showInfo: function showInfo(newVal, oldVal) {
      var tipDom = document.querySelector('.iv-home-ranking');
      if (!this.showInfo) {
        if (tipDom) {
          tipDom.style.marginBottom = '0';
        }
      }
    },
    '$route': function $route() {
      if (this.atIndexHome) {
        window.scrollTo(0, 0);
        this.showInfo = true;
        this.getVideoInfo();
      } else {
        this.showInfo = false;
      }
    }
  },
  computed: {
    atIndexHome: function atIndexHome() {
      return this.$route.name == 'index';
    }
  },
  created: function created() {
    if (this.atIndexHome) {
      this.showInfo = true;
      this.getVideoInfo();
    } else {
      this.showInfo = false;
    }
    window.onscroll = null;
    this.getCopyRright();
  },

  methods: {
    getPosition: function getPosition(footerDom) {
      var scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop;
      if (scrollY >= this.total) {
        this.isBottom = false;
        return;
      }
      this.isBottom = true;
    },
    initBottomScroll: function initBottomScroll() {
      var scrollY = window.pageYOffset || (document.documentElement || document.body).scrollTop;
      var height = (document.documentElement || document.body).offsetHeight;
      var footerTop = this.$refs.Footer.getBoundingClientRect().top;
      this.total = scrollY + footerTop - height;
      this.getPosition();
    },
    initScroll: function initScroll() {
      var _this = this;

      var footerDom = document.querySelector('.iv-footer');
      this.initBottomScroll();
      this.$on('hook:beforeDestroy', function () {
        window.onscroll = null;
        window.onresize = null;
      });
      window.onscroll = function () {
        _this.getPosition(footerDom);
      };
      window.onresize = function () {
        _this.initBottomScroll();
        _this.getPosition(footerDom);
      };
    },

    //获取最后学习信息
    getVideoInfo: function getVideoInfo() {
      var _this2 = this;

      this.$ajax({
        url: 'api-course/portal/open/usercourse/getLastLearnInfo',
        method: 'get'
      }).then(function (res) {
        _this2.courseID = res.data.data.courseID;
        _this2.courseName = res.data.data.courseName;
      }).catch(function () {
        _this2.showInfo = false;
      });
    },

    // 获取落款信息
    getCopyRright: function getCopyRright() {
      var _this3 = this;

      this.$ajax({
        url: 'api-information/portal/information/getSpecificCategory',
        method: 'get',
        data: {
          searchCategoryCode: 'copy_right'
        }
      }).then(function (_ref) {
        var data = _ref.data;

        _this3.copyRightData = data.data[0] && data.data[0].informationDetail;
      });
    },

    //关闭提示信息
    closeInfo: function closeInfo() {
      this.showInfo = false;
    },

    //跳转课程详情
    jumpDetail: function jumpDetail() {
      this.$router.push({
        path: '/course/course-detail',
        query: {
          courseID: this.courseID
        }
      });
    },

    //继续学习
    continueLearn: function continueLearn() {
      this.pushPlay({
        courseId: this.courseID
      });
    },

    //app下载
    downApp: function downApp() {},

    //帮助中心
    helpCenter: function helpCenter() {
      this.$router.push({
        name: 'dynamicList',
        query: {
          help: 'help_center'
        }
      });
    },

    //关于我们
    aboutWe: function aboutWe() {
      var _this4 = this;

      this.$ajax({
        url: 'api-information/portal/information/getSpecificCategory',
        method: 'get',
        data: {
          searchCategoryCode: 'about_us'
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        var list = data.data[0] || {};
        if ((0, _keys2.default)(list).length) {
          _this4.$router.push({
            name: 'dynamicDetail',
            query: {
              informationID: list.informationID
            }
          });
        }
      });
    }
  },
  components: {
    Poptip: _iview.Poptip,
    IconFont: _iconfont2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//